// extracted by mini-css-extract-plugin
module.exports = {"chartRoot":"ZtI8h7nm","title":"AQjLAHFs"};